import React from "react";

const NotFound = () => {
  return (
    <section className="py-5 " style={{ height: "100vh" }}>
      <div className="container">
        <div className="row w-50 m-auto">
          <h1 className="text-light bg-danger p-5 text-uppercase fw-bold">
            😒 404 NOT Found
          </h1>
        </div>
      </div>
    </section>
  );
};

export default NotFound;
